<section [class]="'page-title-area' + (('services.image' | translate).length > 0 ? ' '+('services.image' | translate) :'item-bg1')">
    <div class="container">
        <div class="section-title section-title-color">
            <span *ngIf="('services.quote' | translate).length > 1" [innerHtml]="'services.quote' | translate"></span>
            <span *ngIf="('services.quote' | translate).length <= 1" style="background-color: transparent !important; color: transparent;">{{'services.quote'}}</span>

            <h2 *ngIf="('services.details.'+serviceId+'.title' | translate).length > 1" [innerHtml]="'services.details.'+serviceId+'.title' | translate"></h2>
            <h2 *ngIf="('services.details.'+serviceId+'.title' | translate).length <= 1" style="background-color: transparent !important; color: transparent;">{{'services.details.'+serviceId+'.title'}}</h2>

            <p *ngIf="('services.details.'+serviceId+'.short_description' | translate).length > 1" [innerHtml]="'services.details.'+serviceId+'.short_description' | translate" [style]="('services.details.'+serviceId+'.short_description' | translate).length < 66 ? 'margin-bottom: 60px': ''"></p>
            <p *ngIf="('services.details.'+serviceId+'.short_description' | translate).length <= 1" style="background-color: transparent !important; color: transparent;">{{'services.details.'+serviceId+'.short_description'}}</p>                                                            
        </div>
    </div>
</section>

<section class="contact-area ptb-100 bg-image">
    <div class="container">
        <div class="row">
            <div class="blog-details">
                <div class="post-image">
                    <img [src]="'assets/img/services-img'+serviceId+'.jpg'" class="img-center" alt="image" loading="lazy">
                </div>

                <app-image-text *ngIf="imageSlider.length > 0"
                    [imageLeft]="false"
                    [lightBackground]="true"
                    [imagePath]=imageSlider[0].url
                    [imageTitle]=imageSlider[0].title
                    [description]="'services.details.'+serviceId+'.long_description' | translate">
                </app-image-text>

                <app-video-text *ngIf="videoPlayer.length > 0"
                    [videoLeft]="false"
                    [lightBackground]="true"
                    [autoPlay]="true"
                    [videoPath]=videoPlayer[0].url
                    [videoType]=videoPlayer[0].type
                    [description]="'services.details.'+serviceId+'.long_description' | translate">
                </app-video-text>                

                <div *ngIf="imageSlider.length <= 0 && videoPlayer.length <= 0" [innerHtml]="'services.details.'+serviceId+'.long_description' | translate">
                </div>           
                     
            </div>
        </div>        
    </div>
</section>

<app-slide-images [images]="imageSlider" *ngIf="imageSlider.length > 1"></app-slide-images>

<app-cta-two id="contact"></app-cta-two>